import { useEffect, useState } from "react";
import { fetchTaxCategories, downloadTaxCategoriesExcel } from "../Api/ViewTaxCategory";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";

const ViewTaxCategory = () => {
  const [taxCategories, setTaxCategories] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadTaxCategories = async () => {
      try {
        const data = await fetchTaxCategories();
        setTaxCategories(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Tax Categories`);
      }
    };

    loadTaxCategories();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadTaxCategoriesExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'TaxCategories_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Tax categories data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="list-title">View Tax Categories</h2>
              <Button className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || taxCategories.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {taxCategories.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Code</th>
                    <th>Description</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {taxCategories.map((category, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{category.code}</td>
                      <td>{category.description}</td>
                      <td>
                        {moment(category.createdOnDate).format('L')} at {category.createdOnTime?.substring(0, 8)}
                      </td>
                      <td>{category.createdBy}</td>
                      <td>
                        {category.changedOnDate ? 
                          `${moment(category.changedOnDate).format('L')} at ${category.changedOnTime}` : 
                          'N/A'}
                      </td>
                      <td>{category.changedBy || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No tax categories found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewTaxCategory;